import MarketSiteForm from '@vo/js/components/MarketSiteForm'
import MarketSiteDrawer from '@vo/js/components/MarketSiteDrawer'

export default (function () {
    MarketSiteForm.create()
    MarketSiteDrawer.create()
})
